// src/axiosInstance.js
import axios from "axios";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: window.localStorage.getItem("BaseURL"), // Set base URL dynamically
});

// Request interceptor to attach the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("Token"); // Assuming you're storing the token in localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token has expired or is invalid
      // Redirect the user to the login page
      window.location.assign("/");
      // removing the token from local storage
      window.localStorage.removeItem("Token");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
